import { render, staticRenderFns } from "./QrCode2.vue?vue&type=template&id=50d7cffa&scoped=true&"
import script from "./QrCode2.vue?vue&type=script&lang=js&"
export * from "./QrCode2.vue?vue&type=script&lang=js&"
import style0 from "./QrCode2.vue?vue&type=style&index=0&id=50d7cffa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d7cffa",
  null
  
)

export default component.exports